import moment from 'moment'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'

function renderLocation(endUser) {
  if (endUser.attributes.display_location) {
    return `${endUser.attributes.display_location} . `
  }
}

function makeDisplay(author, endUser, timestamp) {
  return (
    <div className="dsg-Regular color-navy-dark">
         {moment(timestamp).format('LLL')} .&nbsp;
         {renderLocation(endUser)}
         {`Sent by ${getDisplayName(author)}`}
    </div>
  )
}

export default makeDisplay



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TimeLine/EventData/helpers.js